<template>
    <div id="budget_alerts_create" class="container-fluid">
        <form>
            <div class="form-group">
                <label for="client_name">ALERT NAME</label>
                <input v-model="alert_name" type="text" class="form-control col-md-5 col-lg-4 col-xl-3" id="alert_name" autofocus>
            </div>

            <div class="form-group my-4">
                <div class="col padding-x0">
                    <label class="mr-3">FREQUENCY</label>
                    <input class="ml-3" type="checkbox" name="daily" value="daily" v-model="dwm"> Daily
                    <input class="ml-5" type="checkbox" name="weekly" value="weekly" v-model="dwm"> Weekly
                    <input class="ml-5" type="checkbox" name="monthly" value="monthly" v-model="dwm"> Monthly
                </div>
            </div>

            <div class="form-group">
                <div class="mb-3">
                    <label>PROJECTS</label>
                </div>

                <label v-if="clients.length > 0">
                    <p-input type="checkbox" class="p-switch p-slim" @change="selectAllClients" :checked="selected_clients.length === clients.length">Select all</p-input>
                </label>
            </div>

            <div class="form-group">
                <div class="col-10 col-xl-8">
                    <div class="row">
                        <div v-for="client in clients" class="col-md-4 col-lg-3 mb-3">
                            <label>
                                <p-input type="checkbox" v-model="selected_clients" class="p-default p-curve single" :value="client.id"> {{ client.name }}</p-input>
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <div class="mb-3">
                    <label>SEND TO</label>
                </div>

                <label v-if="users.length > 0">
                    <p-input type="checkbox" class="p-switch p-slim" @change="selectAllUsers" :checked="selected_users.length === users.length">Select all</p-input>
                </label>
            </div>

            <div class="form-group">
                <div class="col-10 col-xl-8">
                    <div class="row">
                        <div v-for="user in users" class="col-md-4 col-lg-3 mb-3">
                            <label>
                                <p-input type="checkbox" v-model="selected_users" class="p-default p-curve single" :value="user.id"> {{ user.full_name }}</p-input>
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="text-center margin-top20">
                <button @click="$router.go(-1)" type="button" class="btn btn-light btn-lg">Back</button>
                <button :disabled="is_form_invalid" @click="save" type="button" class="btn btn-info btn-lg">Update Alert</button>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        created() {
            this.fetchServerData();
        },

        data() {
            return {
                alert_name:         '',
                clients:            [],
                selected_clients:   [],
                users:              [],
                selected_users:     [],
                is_form_invalid:    true,
                original_form_data: {},
                dwm:[]
            }
        },

        methods: {
            fetchServerData() {
                axios.all([
                    axios.get('/api/clients'),
                    axios.get('/api/users'),
                    axios.get(`/api/budget/alerts/${this.$route.params.id}`)
                ])
                .then(axios.spread((clients, users, alert) => {
                    this.clients                 = clients.data;
                    this.users                   = _.filter(users.data, {user_type: 'Super Admin'});
                    this.alert_name              = alert.data.name;
                    this.selected_clients        = alert.data.client_ids;
                    this.selected_users          = alert.data.user_ids;
                    if(alert.data.isDaily){
                        this.dwm.push('daily');
                    }
                    if(alert.data.isWeekly){
                        this.dwm.push('weekly');
                    }
                    if(alert.data.isMonthly){
                        this.dwm.push('monthly');
                    }

                    this.saveOriginalFormData();
                }));
            },

            saveOriginalFormData() {
                this.original_form_data.selected_users      = this.selected_users;
                this.original_form_data.selected_clients    = this.selected_clients;
                this.original_form_data.alert_name          = this.alert_name;
                this.original_form_data.dwm                 = this.dwm;
            },

            selectAllClients(isChecked) {
                this.selected_clients = [];

                if (isChecked) {
                    _.each(this.clients, client => {
                        this.selected_clients.push(client.id);
                    });
                }
            },

            selectAllUsers(isChecked) {
                this.selected_users = [];

                if (isChecked) {
                    _.each(this.users, user => {
                        this.selected_users.push(user.id);
                    });
                }
            },

            save() {
                let formData = new FormData;
                formData.append('alert_name', this.alert_name);
                formData.append('frequency', JSON.stringify(this.dwm));
                formData.append('selected_clients', JSON.stringify(this.selected_clients));
                formData.append('selected_users', JSON.stringify(this.selected_users));
                formData.append('_method', 'PUT');

                this.ajaxSubmit({}, 'POST', `/api/budget/alerts/${this.$route.params.id}`, formData).then(response => {
                    this.$notify({
                        type: 'success',
                        text: this.messages.BUDGET_ALERT_UPDATED
                    });

                    this.$router.push({path: '/budget/alerts'});
                });
            },

            validate() {
                this.is_form_invalid = true;
                if (
                    (this.original_form_data.alert_name != this.alert_name)
                    || (this.original_form_data.dwm != this.dwm)
                ) {
                    this.is_form_invalid = false;
                }

                _.each(this.selected_users, (user) => {
                    if(_.indexOf(this.original_form_data.selected_users, user) == -1){
                        this.is_form_invalid = false;
                    }
                });

                _.each(this.selected_clients, (client) => {
                    if(_.indexOf(this.original_form_data.selected_clients, client) == -1){
                        this.is_form_invalid = false;
                    }
                });
            }
        },

        watch: {
            alert_name() {
                this.validate();
            },
            dwm(){
                this.validate();
            },
            selected_clients() {
                this.validate();
            },

            selected_users() {
                this.validate();
            }
        }
    }
</script>

<style lang="scss">
    @import '~@/_variables.scss';

    #budget_alerts_create {
        .pretty.p-default input:checked ~ .state label::after {
            background-color:$secondary !important;
        }

        .pretty.p-switch input:checked ~ .state label::after {
            background-color:$secondary !important;
        }
        .pretty{
            line-height:1 !important;
        }
    }
</style>
